import React, { useEffect } from 'react';

import moment from 'moment/moment';

import { useProcurement } from '../context/ProcurementContext';

import { formatFigure } from 'Helpers/formatService';

import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';
import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';

import useApiRequest from 'Hooks/useApiRequest';
import { useCustomEvent } from 'Hooks/useGlobalDOMEvents';
import usePagination from 'Hooks/usePagination';

export default function HighPriorityProcurementsTable(props) {
    const { routes } = useProcurement();

    const pagination = usePagination();

    const { data: procurements, get: fetchHighPriorityProcurements, loading } = useApiRequest({ url: routes.fetchHighPriorityProcurementsUrl });

    useCustomEvent({
        eventName: 'REFETCH_PROCUREMENT_DASHBOARD',
        onSignal: () => {
            fetchHighPriorityProcurements();
        },
    });

    useEffect(() => {
        fetchHighPriorityProcurements({ page: pagination.page });
    }, [pagination.page]);

    useEffect(() => {
        if (procurements) {
            const { meta } = procurements;
            pagination.setTotal(meta.total);
            pagination.setLastPage(meta.last_page);
            pagination.setFrom(meta.from);
            pagination.setTo(meta.to);
        }
    }, [procurements]);

    return (
        <div>
            <div className="tw-flex tw-items-end tw-justify-between tw-mb-6">
                <div className="tw-flex tw-flex-col tw-gap-y-1">
                    <h4 className="table__header">{$t('High Priority Procurements')}</h4>
                    <div className="table__pagination-info">
                        <PaginationInfo to={pagination.to} from={pagination.from} total={pagination.total} />
                        <TablePagination lastPage={pagination.lastPage} pageChange={(data) => pagination.setPage(+data.selected + 1)} />
                    </div>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th>{$t('Name')}</th>
                            <th>{$t('Description')}</th>
                            <th>{$t('Value')}</th>
                            <th>{$t('Owner')}</th>
                            <th>{$t('Status')}</th>
                            <th>{$t('Scope to Market')}</th>
                            <th>{$t('Contract Award')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <TableRowSkeleton rows={10} columns={7} />}
                        {!loading && !procurements?.data?.length && (
                            <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
                                <td colSpan="100" className="tw-p-4">
                                    <span>{$t('No Procurements found')}</span>
                                </td>
                            </tr>
                        )}
                        {!loading &&
                            !!procurements?.data?.length &&
                            procurements.data.map((procurement) => <ProcurementRow key={procurement.id} procurement={procurement} />)}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function ProcurementRow({ procurement }) {
    return (
        <tr>
            <td>{procurement.name}</td>
            <td>{procurement.description}</td>
            <td className="inbud-numeric-cell">{formatFigure(procurement.value)}</td>
            <td>{procurement.owner_name}</td>
            <td>{procurement.status_title}</td>
            <td className="inbud-date-cell">{moment(procurement.target_scope_issue_to_market_date, 'YYYY-MM-DD').format('YYYY-MM-DD')}</td>
            <td className="inbud-date-cell">{moment(procurement.target_contract_award_date, 'YYYY-MM-DD').format('YYYY-MM-DD')}</td>
        </tr>
    );
}
